import _ from 'underscore';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';
import SOVColumns from '../common-columns/legacy-sov-columns';
import SOVLostColumns from '../common-columns/sov-lost-columns';
import AudienceSOVColumns from '../common-columns/audience-sov-columns';

export function getName() {
  // only PerformanceGrid has inline download, BudgetGrid has not
  return 'PerformanceGrid';
}

export function getColumnsMetadata() {
  return _.defaults({
    AccountName: ['Name', 'AccountNumber'],
    AccountInactiveReasons: ['AccountInactiveReasons', 'AccountInactiveReasonsCount'],
    TotalEffectiveCost: 'PerformanceMetrics/Spend',
    IOPurchaseOrder: 'InsertionOrderDetails/CurrentInsertionOrder/PurchaseOrder',
    IOBudget: 'InsertionOrderDetails/CurrentInsertionOrder/Budget',
    RemainingIOBudget: 'InsertionOrderDetails/CurrentInsertionOrder/RemainingBudget',
    StartDate: 'InsertionOrderDetails/CurrentInsertionOrder/StartDate',
    EndDate: 'InsertionOrderDetails/CurrentInsertionOrder/EndDate',
    DailyBudget: 'Budget/DailyBudget',
    TotalRemainingIOBudget: 'InsertionOrderDetails/TotalRemainingBudget',
    OverallEndDate: 'InsertionOrderDetails/OverallEndDate',
    QualityScore: 'QualityScoreData/OverallQualityScore',
  }, _.omit(PerformanceMetricsColumns, 'Spend'), SOVColumns, SOVLostColumns, AudienceSOVColumns);
}

export function getPage() {
  return 'AccountsSummary';
}

export function getRoute() {
  return 'customer/:customer_id/accounts-summary/performance';
}
